<template>
  <div class="">
    <sub-tab :currentTab="tab" :subTab="subTab"></sub-tab>
    <top v-if="tab === 'top'" :currentTab="tab"></top>
    <inventory-inquiry v-if="tab === 'inventory' && subTab === 'inventory-inquiry'"></inventory-inquiry>
    <inventory-end-of-month v-if="tab === 'inventory' && subTab === 'inventory-end-of-month'"></inventory-end-of-month>
    <delivery-status-inquiry v-if="tab === 'delivery'" :currentTab="tab" :subTab="subTab"></delivery-status-inquiry>
    <shipping-cost v-if="tab === 'expense-details' && subTab === 'shipment-record'"></shipping-cost>
    <other-cost v-if="tab === 'expense-details' && subTab === 'storage-fees'"></other-cost>
    <setting-across-price-diff v-if="tab === 'settings' && subTab === 'price-diff'"></setting-across-price-diff>
    <shipping-list v-if="tab === 'shipping' && subTab === 'shipping-status-inquiry'"></shipping-list>
    <multi-channel-shipping v-if="tab === 'shipping' && subTab === 'multi-channel'"></multi-channel-shipping>
  </div>
</template>
<script>
import Top from './Top'
import InventoryInquiry from './InventoryInquiry'
import InventoryEndOfMonth from './InventoryEndOfMonth'
import DeliveryStatusInquiry from './DeliveryStatusInquiry'
import ShippingCost from './ShippingCost'
import OtherCost from './OtherCost'
import SettingAcrossPriceDiff from './SettingAcrossPriceDiff'
import SubTab from './Subtab'
import ShippingList from './ShippingStatusInquiry'
import MultiChannelShipping from './MultiChannelShipping'

export default {
  data () {
    return {
    }
  },
  components: {
    SubTab,
    Top,
    InventoryInquiry,
    InventoryEndOfMonth,
    DeliveryStatusInquiry,
    ShippingCost,
    OtherCost,
    SettingAcrossPriceDiff,
    ShippingList,
    MultiChannelShipping
  },
  props: {
    tab: {
      type: String,
      default: 'top'
    },
    subTab: {
      type: String,
      default: ''
    }
  }
}
</script>
<style scoped>
.tab-content {
  padding: 10px;
  margin-top: 10px;
}

</style>



// WEBPACK FOOTER //
// src/view/warehouseSc/TabContent.vue